export default "__VITE_ASSET__1e827360__"